/**
 * Ecossistema Guebly — empresas operacionais da holding.
 *
 * Usado na seção "Ecossistema" do site de carreiras para mostrar ao
 * candidato que ele entra numa holding com várias frentes, não numa
 * empresa única. Cores e iniciais espelham o site institucional
 * (Guebly/src/assets/data/companies.json).
 *
 * `build` = resumo do tipo de trabalho/desafio de quem atua na frente.
 * `logo`  = logo oficial da marca, espelhada do site da holding em
 *           public/assets/companies/. Quando `null`, o card cai no
 *           fallback das iniciais coloridas.
 * `status`: "ativa" | "em_desenvolvimento".
 */
export const ECOSYSTEM = [
  {
    slug: "studio",
    name: "Guebly Studio",
    initials: "GS",
    logo: "/assets/companies/studio.png",
    color: "#3B6FB0",
    segment: "Branding · Produto · Automação",
    desc: "Estúdio criativo e técnico da holding. Tira projetos do papel com marca, produto digital e automações ponta a ponta.",
    build: "Design, front-end, back-end e integrações em produção para clientes B2B e marcas internas.",
    tags: ["Design", "Front-end", "Automação"],
    status: "ativa",
  },
  {
    slug: "pay",
    name: "Guebly Pay",
    initials: "GP",
    logo: "/assets/companies/pay.png",
    color: "#8E44C9",
    segment: "Fintech · Pagamentos",
    desc: "Gateway de pagamentos proprietário que conecta todo o grupo. Caminha para virar produto fintech independente.",
    build: "Checkout, antifraude, APIs de pagamento e dashboards financeiros de alta confiabilidade.",
    tags: ["Fintech", "Back-end", "Segurança"],
    status: "ativa",
  },
  {
    slug: "contabil",
    name: "Guebly Contábil",
    initials: "GC",
    logo: "/assets/companies/contabil.png",
    color: "#3A6FD8",
    segment: "Contabilidade · BPO financeiro",
    desc: "Contabilidade digital para MEI e pequenas empresas, integrada ao Pay e com automação fiscal de verdade.",
    build: "Portais didáticos, automação de obrigações fiscais e relatórios financeiros para empreendedores.",
    tags: ["Produto", "Fiscal", "Dados"],
    status: "ativa",
  },
  {
    slug: "games",
    name: "Guebly Games",
    initials: "GG",
    logo: "/assets/companies/games.png",
    color: "#6D4AFF",
    segment: "Games · Experiências digitais",
    desc: "Estúdio de jogos e experiências interativas. Une narrativa, imersão e inovação técnica.",
    build: "Jogos autorais, experiências XR e gamificação aplicada — do protótipo às stores.",
    tags: ["Games", "Criativo", "XR"],
    status: "ativa",
  },
  {
    slug: "lirya",
    name: "Lirya",
    initials: "LY",
    logo: "/assets/companies/lirya.png",
    color: "#4F46E5",
    segment: "Educação · Streaming",
    desc: "Ecossistema de educação e entretenimento: Lirya Studios (produção), Lirya+ (streaming) e Lirya Academy (cursos).",
    build: "Plataforma de streaming, trilhas de aprendizado e produção de conteúdo original.",
    tags: ["Edtech", "Streaming", "Conteúdo"],
    status: "ativa",
  },
  {
    slug: "sentrion",
    name: "Sentrion",
    initials: "SN",
    logo: "/assets/companies/sentrion.png",
    color: "#2563C9",
    segment: "Segurança · Visão computacional",
    desc: "Segurança inteligente com IA: Sentrion Vision (câmeras com visão computacional) e Alarm (alarmes integrados).",
    build: "Modelos de visão computacional, IoT e detecção de ameaças em tempo real.",
    tags: ["IA", "Visão computacional", "IoT"],
    status: "em_desenvolvimento",
  },
];
